/*
 * This list is used mainly to populate the custom type menu
 * in the admin dashboard, i.e. it determines which types are available
 * for admins to choose from.
 *
 * Notes:
 * - When adding to this list, keep in mind that translations have
 *   to be added for each new type. Translation keys for types follow
 *   the format `file_type_${type.value}`
 * - The icon field only controls the icon displayed in the admin menu.
 *   By default, components will look for an icon following the format
 *   `asset-${type.value}`. If you want to map a type to a different icon,
 *   either add this mapping to the iconMap of components/Icon (if it's generic)
 *   or add it to the `typeToIconMap` in the getAssetIcon utility
 *   (if it's highly hub-specific).
 *
 * - Dion
 */

var generalTypes = [{
  value: 'activity',
  icon: 'asset-activity'
}, {
  value: 'article',
  icon: 'asset-text'
}, {
  value: 'assessment',
  icon: 'asset-quiz'
}, {
  value: 'elearning',
  icon: 'asset-fluidbook'
}, {
  value: 'fluidbook',
  icon: 'asset-fluidbook'
}, {
  value: 'infographic',
  icon: 'asset-infographic'
}, {
  value: 'podcast',
  icon: 'asset-podcast'
}, {
  value: 'quiz',
  icon: 'asset-quiz'
}, {
  value: 'survey',
  icon: 'asset-quiz'
}, {
  value: 'video',
  icon: 'asset-video'
}, {
  value: 'webinar',
  icon: 'asset-webinar'
}, {
  value: 'workshop',
  icon: 'team'
}, {
  value: 'event',
  icon: 'calendar'
}];
export { generalTypes };